import { Box } from '@mui/material';

export const LoginContainer = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
    }}
  >
    {children}
  </Box>
);
